import axios from "axios";
import { BaseUrl } from "./config";
import Cookies from "js-cookie";

const Axios = axios.create({ baseURL: BaseUrl });

Axios.interceptors.request.use(
  (AxiosConfig) => {
    const newConfig = { ...AxiosConfig };
    newConfig.withCredentials = true;
    if (!newConfig.headers["Content-Type"]) {
      newConfig.headers["Content-Type"] = "application/json";
    }
    return newConfig;
  },
  (error) => {
    Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      (error.response.status == 401 && Cookies.get("liResponse"))
    ) {
      Cookies.remove("liResponse");
      alert("نشست شما منقضی شده است، دوباره وارد شوید.");
      window.open(`/login`, "_self");
    }
    return Promise.reject(error);
  }
);

export default {
  GET: Axios.get,
  POST: Axios.post,
  PUT: Axios.put,
  PATCH: Axios.patch,
  DELETE: Axios.delete,
};
